import { useEffect, useState } from 'react';
import MlbNativeWrapper from '../MlbNativeWrapper';
import { useAccessToken } from './usePermissionToTrack';
import { useDispatch } from 'react-redux';
import authReady from '@gameday/core/actions/authReady';
const LOGIN_SUCCESS = "LOGIN_SUCCESS";

const useNativeLoginFunc = () => {
    const dispatch = useDispatch();
    const accessToken = useAccessToken();
    const [loginFn, setLoginFn] = useState(undefined);

    useEffect(() => {
        MlbNativeWrapper.then((results) => {
            const { login } = results;
            if (typeof login === 'function') {
                setLoginFn({
                    login: () => {
                        return new Promise((resolve, reject) => {
                            return login().then((status) => {
                                if (accessToken) {
                                    resolve(LOGIN_SUCCESS);
                                } else {
                                    if (status === LOGIN_SUCCESS) {
                                        dispatch(authReady);
                                        resolve(status);
                                    } else {
                                        reject(status);
                                    }
                                }
                            }).catch((err) => {
                                reject(err);
                            })
                        });
                    }
                });
            }
        });
    }, [accessToken, MlbNativeWrapper, setLoginFn])

    return loginFn?.login

}

export default useNativeLoginFunc;